import { render, staticRenderFns } from "./ChatMessageTable.vue?vue&type=template&id=6a3d94cf&scoped=true"
import script from "./ChatMessageTable.vue?vue&type=script&lang=js"
export * from "./ChatMessageTable.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageTable.vue?vue&type=style&index=0&id=6a3d94cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d94cf",
  null
  
)

export default component.exports